export var phoneValidationRegEx = /^\(\d{3}\)\s\d{3}-\d{4}$/;
export var ssnValidationRegEx = /^\d{3}-\d{2}-\d{4}$/;
export var zipCodeValidationRegEx = /^\d{5}(?:[-\s]\d{4})?$/;
